module.exports = __webpack_public_path__ + "static/media/mouse-pointer.5c06f5f5.svg";